@file:OptIn(ExperimentalSerializationApi::class)

package ai.flowstorm.studio.model

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.id.newId
import ai.flowstorm.common.model.AbstractEntity
import ai.flowstorm.studio.util.toDate
import io.kvision.i18n.gettext
import io.kvision.moment.Moment
import kotlinx.datetime.Instant
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames
import kotlin.math.round
import kotlin.math.roundToInt

fun Double.round(decimals: Int): Double {
    var multiplier = 1.0
    repeat(decimals) { multiplier *= 10 }
    return round(this * multiplier) / multiplier
}

@Serializable
data class ProfileRecord (
    override val _id: Id = newId(),
    val content: String = "",
    val language: String? = null,
    val llmModel: String? = null,
    val embeddingModel: String? = null,
    val personaName: String? = null,
    val reliability: Double = 0.0,
    val transcriptText: String? = null,
    val transcriptConfidence: String? = null,
    val transcript: Input.Transcript? = null,
    val timestamp: Instant,
    val session_id: String,
    val turn_id: String,
    val user_id: String,
    val categories: List<String> = emptyList(),
    val tags: List<String> = emptyList(),
    val rankScore: Double? = null
) : AbstractEntity() {

    override val label: String
        get() = user_id.toString()

    var categoriesAsText: String = ""
    var tagsAsText: String = ""
    var timestampAsText: String = ""
    var reliabilityAsText: String = ""

    init {
        categoriesAsText = categories.joinToString(", ")
        tagsAsText = tags.joinToString(", ")
        timestampAsText = Moment(timestamp.toDate()).format(gettext("YYYY/MM/DD HH:mm")) as String
        reliabilityAsText = reliability.times(100).roundToInt().toString()
    }
}

@Serializable
@Suppress("unused")
enum class Category {
    @JsonNames("well-being")
    WELL_BEING,

    @JsonNames("personal-information-about-user")
    PERSONAL_INFORMATION_ABOUT_USER,

    @JsonNames("events-experiences-memories")
    EVENTS_EXPERIENCES_MEMORIES,

    @JsonNames("goals-plans-wishes")
    GOALS_PLANS_WISHES,

    @JsonNames("information-about-other-beings")
    INFORMATION_ABOUT_OTHER_BEINGS,

    @JsonNames("world-information")
    WORLD_INFORMATION,

    @JsonNames("app-related-information")
    APP_RELATED_INFORMATION
}

@Serializable
@Suppress("unused")
enum class Tag {
    @JsonNames("mental")
    MENTAL,

    @JsonNames("physical")
    PHYSICAL,

    @JsonNames("social")
    SOCIAL,

    @JsonNames("financial")
    FINANCIAL
}
